import React from 'react'

class FullscreenItemPreload extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    
    var item = this.props.item;
    var idx = this.props.item.idx;
    
    if (item.isText) {
      return <div/>;
    } else {
      var transform = 'translate3d(-50%, -50%, 0) scale(' + this.props.window.scale.min(item) + ')';
      var innerStyle = {
        'width': item.width + 'px',
        'height': item.height + 'px',
        'backgroundColor': item.bgColor,
        'transform': transform,
        'WebkitTransform': transform,
        'MozTransform': transform,
        'msTransform': transform,
        'OTransform': transform
      };
      
      return (item.preload_img) ? (
        <div className={"fullscreen-preload fullscreen-preload-" + idx}
             key={'preload_container'}
        >
          <img className={'fullscreen-item fullscreen-item-preload'}
               src={item.preload_img}
               style={innerStyle}
               key={'preload'}
          />
          {this.props.loaded ? false : (<div className="pro-circle-preloader"></div>)}
        </div>
      ) : <div/>;
    }
  };
}

export default FullscreenItemPreload




// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenItemPreload.js